// eslint-disable-next-line import/no-internal-modules
import ColorPicker from '@insided/deprecated-preact-components/theme-configuration/ColorPicker'
import { Component } from 'preact'
import FieldContainer from './FieldContainer'
import { AbstractFieldProps } from './types'

export type BackgroundColorValue = string

export interface BackgroundColorFieldProps extends AbstractFieldProps<BackgroundColorValue> {}

interface FieldState {
  value: BackgroundColorValue
  // isColorSelectorEnabled should be hidden inside implementation of ColorPicker
  isColorSelectorEnabled: boolean
}

export const DEFAULT_BACKGROUND_COLOR = '#c4c4c4'

export class BackgroundColorField extends Component<BackgroundColorFieldProps, FieldState> {
  state = {
    isColorSelectorEnabled: false,
    value: this.props.value ?? DEFAULT_BACKGROUND_COLOR
  }

  render() {
    return (
      <FieldContainer inputId='widget-background-color-picker' title='Background Color'>
        <ColorPicker
          id='widget-background-color-picker'
          position='top'
          color={this.state.value}
          disabled={false}
          isColorSelectorEnabled={this.state.isColorSelectorEnabled}
          updateColor={this.props.onValueChange}
          disableColorSelector={() => this.setState({ isColorSelectorEnabled: false })}
          setColorSelector={() => this.setState({ isColorSelectorEnabled: true })}
        />
      </FieldContainer>
    )
  }
}

export default BackgroundColorField
